import React from 'react';
import { read } from 'react-read';
import { webgateFetch, WEBGATE_DOMAIN } from '../lib/api';
import { withHooks } from '../lib/withHooks';
import { createLoader } from '../dataloader';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function load(_key: 0) {
  const response = await webgateFetch(`${WEBGATE_DOMAIN}/s4x-me/v0/me`);
  if (response.status === 401) return null;
  if (!response.ok) throw new Error(`${response.status} ${response.url}`);
  const me = (await response.json()) as Response;
  return { email: me.loginEmail, ...me } as const;
}

export const currentUserLoader = createLoader(load);

if (process.env.NODE_ENV !== 'test') {
  // eagerly start loading
  currentUserLoader.load(0);
}

export function useCurrentUser() {
  const currentUser = React.useMemo(() => {
    return read(currentUserLoader.load(0));
  }, []);

  return currentUser;
}

export const withCurrentUser = withHooks(() => ({
  currentUser: useCurrentUser(),
}));

type Response = {
  name: string;
  username: string;
  loginEmail: string;
  imageUrl: string;
  largeImageUrl: string;
  hasAccess: boolean;
  partnerIds: {
    google: string;
  };
};
